import { createAsyncThunk } from "@reduxjs/toolkit";

import * as URL from "../../helpers/url_helper";

import { get, post, put } from "../../helpers/api_helper";
//EDIT_CHARACTER_REQUEST
export const getCharRequestList = createAsyncThunk(
  "getCharRequestList",
  async ({ data, callback }, Thunk) => {
    try {
      let response = await post(URL.GET_CHARACTER_REQUEST_LIST, data);
      callback && callback(null, response);
      return response;
    } catch (error) {
      console.log(error, "error action");
      callback && callback(error || error.message || error);
      return Thunk.rejectWithValue(error);
    }
  }
);

export const editCharRequest = createAsyncThunk(
    "editCharRequest",
    async ({ data, callback }, Thunk) => {
      try {
        let response = await post(URL.EDIT_CHARACTER_REQUEST, data);
        callback && callback(null, response);
        return response;
      } catch (error) {
        console.log(error, "error action");
        callback && callback(error || error.message || error);
        return Thunk.rejectWithValue(error);
      }
    }
  );
  